import { ArrowDownRight, ArrowUpRight } from 'lucide-react';

import { Badge } from '@/common/components/ui/badge';

interface VariationBadgeProps {
  value?: number | null;
}

export const VariationBadge = ({ value }: VariationBadgeProps) => {
  if (value === undefined || value === null || Number.isNaN(value)) return '-';

  const isNotZero = value != 0;
  const isPositive = value >= 0;

  const arrow = isPositive ? (
    <ArrowUpRight size={14} />
  ) : (
    <ArrowDownRight size={14} />
  );

  const nonZeroVariant = isPositive ? 'error' : 'success';
  const variant = isNotZero ? nonZeroVariant : 'warning';

  return (
    <Badge variant={variant} className="px-1.5 py-0.5">
      {isNotZero && arrow}
      {formatVariation(value)}
    </Badge>
  );
};

const formatVariation = (value: number): string => {
  return Intl.NumberFormat('default', {
    style: 'percent',
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  }).format(value);
};
